/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useBenefitTag } from '../../../../hooks';
import { SQUARE_BENEFITS_CONSTANTS as CONSTANTS } from './Constants';
export var SquareBenefitsLogo = function () { return (React.createElement("div", { "data-testid": "sb-icon", className: "sui-mt-1 sui-min-w-[91px]" },
    React.createElement("img", { src: CONSTANTS.ICON_URL, alt: "Square", width: "91", height: "23" }))); };
export var SquareBenefitsHeadline = function (_a) {
    var amt = _a.amt;
    return (React.createElement("div", { className: "sui-mb-4" },
        React.createElement(Typography, { variant: "h5" }, CONSTANTS.HEADLINE(amt))));
};
export var SquareHeaderDTW = function () {
    var HeaderDivider = function () { return (React.createElement("div", { "data-testid": "sb-divider", className: "sui-w-2px sui-bg-inverse" })); };
    var ProXtraLogo = function () { return (React.createElement("div", { "data-testid": "sb-title", className: "sui-py-1" },
        React.createElement("img", { className: "sui-h-6 lg:sui-h-[34px]", src: CONSTANTS.TIER_URL, alt: "Square", width: "auto", height: "auto" }))); };
    var SquareLogo = function () { return (React.createElement("div", { "data-testid": "sb-icon", className: "sui-mt-1" },
        React.createElement("img", { className: "sui-h-6 lg:sui-h-[31px]", src: CONSTANTS.ICON_URL, alt: "Square", width: "auto", height: "auto" }))); };
    return (React.createElement("div", { "data-testid": "sb-header", className: "sui-bg-pro-sawdust sui-p-6 sui-flex sui-gap-4\n      sui-absolute sui-left-[-24px] sui-right-[-24px] sui-top-[-24px]" },
        React.createElement(ProXtraLogo, null),
        React.createElement(HeaderDivider, null),
        React.createElement(SquareLogo, null)));
};
export var SquareConent = function (props) {
    var isLocked = props.isLocked, tierName = props.tierName;
    var phoneLine = useBenefitTag(CONSTANTS.FOOTER.PHONE_TAG);
    var LOCK_TEXT = isLocked ? 'LOCKED' : 'UNLOCKED';
    var TierMessage = function () { var _a; return (_a = CONSTANTS.MESSAGE["".concat(tierName === null || tierName === void 0 ? void 0 : tierName.toUpperCase())]) === null || _a === void 0 ? void 0 : _a[LOCK_TEXT]; };
    var Message = function () { return (React.createElement("div", { className: "sui-mb-4 md:sui-mb-8" },
        React.createElement(Typography, { variant: "body-base" },
            React.createElement(TierMessage, null)))); };
    var FooterHeadline = function () { return (React.createElement("div", { className: "sui-mb-4 md:sui-mb-3" },
        React.createElement(Typography, { variant: "h6" }, CONSTANTS.FOOTER.HEADLINE))); };
    var PhoneLabel = function () { return (React.createElement("span", { className: "sui-inline-block sui-mr-1" },
        React.createElement(Typography, { variant: "body-base" },
            React.createElement("span", { className: "md:sui-hidden" }, CONSTANTS.FOOTER.MESSAGE.MW),
            React.createElement("span", { className: "sui-hidden md:sui-block" }, CONSTANTS.FOOTER.MESSAGE.DTW)))); };
    var PhoneNumber = function () { return (React.createElement("span", { className: "sui-text-base sui-inline-block sui-underline md:sui-no-underline" },
        React.createElement("a", { className: "sui-font-w-bold md:sui-hidden", href: 'tel:' + phoneLine }, phoneLine),
        React.createElement("span", { className: "max-md:sui-hidden" },
            React.createElement(Typography, { variant: "body-base" },
                phoneLine,
                ".")))); };
    return (React.createElement("div", null,
        React.createElement(Message, null),
        !isLocked && phoneLine && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-relative sui-h-10 sm:sui-h-auto" },
                React.createElement("div", { className: "sui-absolute sm:sui-relative sui-w-[300px] sm:sui-w-auto" },
                    React.createElement(FooterHeadline, null))),
            React.createElement("div", { className: "sui-flex sui-flex-col sm:sui-inline-block" },
                React.createElement(PhoneLabel, null),
                React.createElement(PhoneNumber, null))))));
};
